import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconPauseStyle0 = gravityIconIndividualCss;

const GravityIconPause = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: '3fb412552ec84e5c10b18a98cbe4cf3903d0ec7b', color: this.color, size: this.size }, h("svg", { key: '834ef40c261d22aa195d2aa993fe90eaf666c62a', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: '61a74258d523d37a8232f4f77d3ca77c8e943db4', d: "M5 4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V4Zm8 0a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1V4Z", fill: "currentColor" }))));
    }
};
GravityIconPause.style = GravityIconPauseStyle0;

export { GravityIconPause as gravity_icon_pause };

//# sourceMappingURL=gravity-icon-pause.entry.js.map